export default "__VITE_ASSET__gdPRyZNE__"